<template>
  <div
    class="stock-thumbnail"
    :class="{ 'desktop': isDesktopView }"
    :style="{ 'background-image': `url(${image})` }"
  >
    <mobile-corner-tag :tag-type="stock.stock_type" v-if="stockTagDisplay" />
    <img 
      v-if="stock.have_video !== '0'"
      class="stock-thumbnail-video-icon"
      src="/ics/property/img/details/video-01-white.svg"        
    />
  </div>
</template>

<script>
import mobileCornerTag from '@/components/Stock/MobileCornerTag';

export default {
  props: ['stock', 'isDesktopView', 'stockTagDisplay'],
  components: {
    mobileCornerTag,
  },
  data() {
    return {
      noPhotoIS: `${window.SITE_URL}img/details/no_photo_is.jpg`,
      noPhotoC: `${window.SITE_URL}img/details/no_photo_c.jpg`,
    };
  },
  computed: {
    image() {
      if (!this.stock.img_path) {
        if (this.stock.ics_type === 's') {
          return this.noPhotoIS;
        }
        return this.noPhotoC;
      }
      return this.stock.img_path;
    },
  },
};
</script>

<style scoped>
.stock-thumbnail {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 158px;
}

.stock-thumbnail.desktop {
  height: 140px;
}

.stock-thumbnail-video-icon {
  width: 12vw;
  max-width: 80px;
  height: auto;
}

@media screen and (orientation:landscape) {
  .stock-thumbnail-video-icon {
    max-width: 80px;
  }
}
</style>